import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';

@Injectable()
export class CustomMatDialog extends MatDialog {
  dialogExceptions = ['LoginDialogComponent', 'RegisterDialogComponent'];

  override open<T, D = any>(component: any, config?: MatDialogConfig<D>): MatDialogRef<T> {
    if (!document.getElementById('custom-dialog-css') && !this.dialogExceptions.includes(component.name)) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'assets/custom-dialog.css';
      link.id = 'custom-dialog-css';
      document.head.appendChild(link);
    }
    return super.open(component, config);
  }
}
